import { FormattedMessage } from "react-intl";

import Alert from "components/v2/Alert/Alert";
import testIds from "constants/testIds";

export default function MultistopPodCompletionWarning() {
  return (
    <div data-testid={testIds.SHIPMENT_DASHBOARD_MULTISTOP_POD_COMPLETION_WARNING}>
      <Alert variant="brand" label="">
        <FormattedMessage
          id="components.molecules.top-nav.multistopPodCompletionWarning"
          defaultMessage="Uploading this POD will mark the whole shipment as Delivered. This action cannot be undone"
        />
      </Alert>
    </div>
  );
}
